import { render, staticRenderFns } from "./massal_kolektif.vue?vue&type=template&id=429a9e03&"
import script from "./massal_kolektif.vue?vue&type=script&lang=js&"
export * from "./massal_kolektif.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports